import { Stack, Text } from "@chakra-ui/react";
import IaasImg from "public/iaas/infrastructure_as_a_service.jpg";
import { useTextVariants } from "@/theme/components/useSectionHeading";

type IntroProps = {
  description: string[];
};

const Content = (props: IntroProps) => {
  const { description } = props;
  const textVariant = useTextVariants();
  return (
    <Stack>
      {description.map((desc, index) => (
        <Text variant={textVariant} key={index} color="text.100">
          {desc}
        </Text>
      ))}
    </Stack>
  );
};

export const INTRO_CONSTANTS = {
  heading: "Infrastructure as a Service (IaaS) – Scalable, Secure & Customizable ",
  title: "What is Infrastructure as a Service (IaaS)?  ",
  description: (
    <Content
      description={[
        "Infrastructure as a Service (IaaS) is a cloud computing model that provides businesses with on-demand, virtualized computing resources over the internet. It eliminates the need for costly physical hardware by offering scalable, pay-as-you-go infrastructure, allowing organizations to focus on their core operations without managing complex IT infrastructure. ",
        "With IaaS, businesses can dynamically allocate computing power, networking, and storage while benefiting from cost savings, security, and scalability.",
      ]}
    />
  ),
  image: IaasImg,
};
